<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="128px"
    height="128px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 128 128"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs>
      <!-- <style type="text/css">
   <![CDATA[
    .fil0 {fill:#2B2A29}
   ]]>
  </style> -->
    </defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_1802351318448">
        <path
          class="fil0"
          d="M33.93 35.52c-1.42,-0.91 -3.07,-1.55 -4.91,-1.55l-18.79 0c0.27,7.83 4.55,12.63 11.23,16.11 0.69,0.36 1.4,0.71 2.11,1.03 1.08,-6.57 4.96,-12.19 10.36,-15.59zm-29.82 17.95l0 7.77 0.09 12.6c1.11,0.41 16.55,0.34 24.75,0.28 -1.77,-3.05 -3.2,-6.3 -4.18,-9.76 -8.71,-1.85 -15.87,-5.13 -20.66,-10.89z"
        />
        <path
          class="fil0"
          d="M4.07 120.92c0,4.94 5.47,8.98 10.28,6.14l2.37 -2.19c0.56,-0.82 0.79,-1.98 0.9,-3.21l-0.05 -29.62 2.93 -0.1c0,9.51 -0.14,19.11 -0.01,28.61 0.14,10.28 13.63,9.38 13.63,-0.02 0,-8.85 0.39,-37.67 -0.08,-44.32l-27.42 -0.03c-1.75,-0.03 -2.55,-0.44 -2.55,1.07l0 43.67z"
        />
        <path
          class="fil0"
          d="M4.07 15.42c0,2.74 1.6,7.05 2.65,8.45l2.45 2.58c0.05,0.05 0.13,0.14 0.19,0.19 0.54,0.54 0.18,0.37 0.98,0.9 0.27,0.18 1.75,0.84 2.35,1.16 2.96,1.56 8.36,2.02 11.65,0.62 1.06,-0.45 0.06,-0.02 0.99,-0.54l2.78 -1.48c0.19,-0.15 1.29,-1.15 1.62,-1.45 3.45,-3.21 5.37,-10.02 3.85,-14.64 -6.01,-18.24 -29.51,-12.34 -29.51,4.21z"
        />
        <path
          class="fil0"
          d="M0.03 39.45c-0.51,-4.18 5.86,-5.96 8.27,-5.45 0.33,9.84 6.45,15.36 15.03,19.11 -0.04,0.58 -0.07,1.16 -0.07,1.75 0,1.47 0.14,2.94 0.42,4.38 0.15,1.03 0.34,2.03 0.56,3.02 -15.73,-3.59 -22.28,-11.53 -24.21,-22.81z"
        />
        <path
          class="fil0"
          d="M88.31 89.89c1.56,0.39 2.09,1.3 3.89,1.91 10.02,3.38 23.48,3.56 32.67,-0.27 3.98,-1.66 3.11,-3.73 2.92,-7.58l-3.99 -31.71c-4.09,8.08 -11.55,12.57 -21.16,15.03 -2.86,7.16 -8.21,13.91 -14.43,19.88 0.01,0.95 0.04,1.86 0.1,2.74zm26.35 -52.97c-2.37,-0.36 -5.02,-0.63 -6.19,-0.64 -4.8,-0.05 -7.6,0.41 -10.82,1.68 4.08,3.72 6.81,8.9 7.36,14.72 5.72,-3.42 9.32,-8.05 9.56,-15.22 0.01,-0.19 0.04,-0.37 0.09,-0.54z"
        />
        <path
          class="fil0"
          d="M108.08 33.99c17.13,0 17.72,-23.73 3.79,-26.88 -3.69,-0.84 -7.83,-0.64 -10.84,1.36 -2.25,1.49 -3.71,2.97 -5.05,5.33 -1.96,3.44 -1.9,9.11 -0.23,12.61 1.43,3.03 4.02,5.03 6.95,6.52 1.51,0.77 3.58,1.06 5.38,1.06z"
        />
        <path
          class="fil0"
          d="M95.11 94.7c0,6.46 0,12.93 0,19.39 0,5.83 -1.4,13.36 4.93,13.87 2.88,0.23 5.1,-1.29 5.93,-3.62 0.78,-2.21 0.34,-24.66 0.34,-28.03 -4.45,-0.2 -7.33,-0.73 -11.2,-1.61z"
        />
        <path
          class="fil0"
          d="M110.12 96.39c0,6.42 0,12.83 0,19.24 0,4.12 -1.66,13.29 6.35,12.3 6.12,-0.76 4.77,-8.28 4.77,-14.23 0,-6.1 -0.31,-13.08 0.07,-19.08 -6.96,1.72 -5.93,0.92 -11.19,1.77z"
        />
        <path
          class="fil0"
          d="M124.77 42.97c0.51,-4.17 -5.86,-5.95 -8.28,-5.45 -0.28,8.38 -4.76,13.63 -11.38,17.32l0 0.02c0,1.45 -0.14,2.9 -0.41,4.33 -0.21,1.98 -0.64,3.93 -1.26,5.86 13.66,-3.87 19.51,-11.51 21.33,-22.08z"
        />
        <path
          class="fil0"
          d="M82.4 34.72c11.07,0 20.05,9.02 20.05,20.14 0,1.35 -0.13,2.66 -0.38,3.93l0 0c-1.63,15.96 -19.67,32.22 -38.09,43.19 -15.49,-9.61 -34.8,-22.96 -37.67,-43.19l0 0c-0.25,-1.27 -0.39,-2.58 -0.39,-3.93 0,-11.12 8.98,-20.14 20.06,-20.14 8.07,0 15.03,4.8 18.21,11.7 3.18,-6.9 10.13,-11.7 18.21,-11.7zm-22.08 15.23l7.74 0c1.08,0 1.97,0.89 1.97,1.98l0 10.56 10.51 0c1.09,0 1.97,0.89 1.97,1.98l0 7.76c0,1.09 -0.88,1.98 -1.97,1.98l-10.51 0 0 10.56c0,1.09 -0.89,1.99 -1.97,1.99l-7.74 0c-1.09,0 -1.97,-0.9 -1.97,-1.99l0 -10.56 -10.52 0c-1.08,0 -1.97,-0.89 -1.97,-1.98l0 -7.76c0,-1.09 0.89,-1.98 1.97,-1.98l10.52 0 0 -10.56c0,-1.09 0.88,-1.98 1.97,-1.98z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSaudeCrianca',
}
</script>

<style></style>
